<template>
  <v-app id="list1">
    <v-main>
      <v-container fluid>
        <v-row dense>
          <v-col cols="2">
            <select_bedr_codes :selected_statcodes="bedrCodesSelected" field="bedrCodesSelected" :isClearable="true"
              @updateData="updateData" :localStorageItem="localStorageItemBedr" class="pr-4"></select_bedr_codes>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <select_status_codes :selected_statcodes="statCodesSelected" field="statCodesSelected" :isClearable="true"
              @updateData="updateData" :localStorageItem="localStorageItemStat" class="pr-4"></select_status_codes>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="2">
            <select_real_test :selected_type="realTestSelected" field="realTestSelected" label="Type" :isClearable="true"
              @updateData="updateData" :canSelectAll="true" :isMultiple="true" :localStorageItem="localStorageItemType"
              class="pr-4"></select_real_test>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
            <m_select_gebr_codes label="Agent(s)" 
              :selected_gebrcodes="gebrCodesSelected" 
              :isClearable="true"
              @updateData="updateData" 
              :localStorageItem="localStorageItemGebr" 
              field="gebrCodesSelected"
              :canSelectAll="true" 
              :isMultiple="true" 
              :isAgent="true" 
              :customOption="{code: 'Non Agents', name: 'Include non agents and inactive agents', custom: true}" class="pr-4">
            </m_select_gebr_codes>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz">Create excel</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
    <lin_prg_bar ref="prgbar" />
  </v-app>
</template>

<script>

  import navBar from "@/components/ui/navbars/navbar.vue";
  import lin_prg_bar from '@/components/ind_prg_horizontal';
  import m_select_gebr_codes from "@/components/ui/selectors/m_select_gebr.vue"
  import select_status_codes from "@/components/ui/selectors/select_status_codes.vue"
  import select_bedr_codes from "@/components/ui/selectors/select_bedr_codes.vue"  
  import select_real_test from "@/components/ui/selectors/select_real_test.vue"  

 export default {
  components: {
    navBar,
    lin_prg_bar,
    m_select_gebr_codes,
    select_status_codes,
    select_bedr_codes,
    select_real_test    
  },
  data() {
    return {
      localStorageItemGebr: 'list1.acco.gebrcodes',
      localStorageItemStat: 'list1.acco.statcodes',
      localStorageItemBedr: 'list1.acco.bedrcodes',
      localStorageItemType: 'list1.acco.typecodes',
      statCodesSelected: [],
      statCodes: [],
      bedrCodesSelected: [],
      bedrCodes: [],
      realTestSelected: [],
      realTest: [],
      gebrCodesSelected: [],
      gebrCode: [],
      items: [],
    }
  },
  created() {
  },
  methods: {
      updateData(data) {
        this[data.field] = data.value;
      },
     ovrz() {
      this.results = true;
      // this.$refs.prgbar.open('Getting accommodation data', true, 1250);
      this.$axios
        .post("ares/json/ares/huis/ovrz/excelExportList1v5.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportList1"
          },
          excelExportList1: {
            stat_codes: this.statCodesSelected,
            bedr_codes: this.bedrCodesSelected,
            real_test: this.realTestSelected,
            agent_codes: this.gebrCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            // this.$refs.prgbar.close();
            console.log(res.data.error);
            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.error,
              color: "error",
            });
          } else {
            this.$refs.prgbar.close();
            this.items = res.data.excelExportList1;

            localStorage.setItem(this.localStorageItemGebr, this.gebrCodesSelected);
            localStorage.setItem(this.localStorageItemStat, this.statCodesSelected);
            localStorage.setItem(this.localStorageItemBedr, this.bedrCodesSelected);
            localStorage.setItem(this.localStorageItemType, this.realTestSelected);

            this.$store.dispatch("setSnackbar", {
              showing: true,
              text: res.data.excelExportList1.text,
              color: res.data.excelExportList1.color,
            });
            // window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          // this.$refs.prgbar.close();
          this.loading = false;
        });
    },

  }
};

</script> 
